/* Scroll reveal — global, vanilla, no dependency.
   .reveal starts at opacity:0 (product.css) and becomes visible once .visible
   is added. Loaded on every template so collection / page sections can use it.

   Exposes window.LavielaReveal(els) for content injected later
   (product recommendations, section rendering API, …).
   prefers-reduced-motion is handled in CSS. */
(function () {
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
  }

  function toArray(els) {
    if (!els) return [];
    if (els.nodeType) return [els];
    return Array.prototype.slice.call(els);
  }

  function observeReveal(els) {
    toArray(els).forEach(function (el) {
      if (io) io.observe(el);
      else el.classList.add('visible');
    });
  }

  window.LavielaReveal = observeReveal;

  function init() {
    observeReveal(document.querySelectorAll('.reveal'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
